import { render, staticRenderFns } from "./SpotOffers.vue?vue&type=template&id=15525814&"
import script from "./SpotOffers.vue?vue&type=script&lang=js&"
export * from "./SpotOffers.vue?vue&type=script&lang=js&"
import style0 from "./SpotOffers.vue?vue&type=style&index=0&id=15525814&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports